import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ProplayerService } from '../../shared/services/proplayer.service';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { LoginPopupComponent } from '../../shared/login-popup/login-popup.component';
import { FormsModule } from '@angular/forms';
import { Subscription, switchMap, timer } from 'rxjs';
import { DecryptionService } from '../../shared/services/decryption.service';
@Component({
  selector: 'app-game-history',
  standalone: true,
  templateUrl: './game-history.component.html',
  styleUrl: './game-history.component.scss',
  providers: [DatePipe, NgModule],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoginPopupComponent,
  ],
})
export class GameHistoryComponent implements OnInit, AfterViewInit {
  playersRecord: any[] = [];
  pageNumber = 1;
  isLoading = false;
  playerdetails: any;
  protected proplayerData!: FormGroup;
  SortDate = 'descendingDate';
  filterForm: any;
  modalDisplayStyle!: boolean;
  playerSide = '';
  playerNames: any;
  playerOpponent: any;
  suggestions: any[] = [];
  opponentsuggestions: any[] = [];

  private playerSearch?: Subscription;
  private opponentPlayerSearch?: Subscription;
  constructor(
    private playerData: ProplayerService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private router: Router,private decryptionApi: DecryptionService
  ) {}

  ngOnInit() {
    this.proplayerData = this.fb.group({
      name: [],
      opponent: [''],
      results: [''],
      date: [''],
      side: [''],
    });
  }

  ngAfterViewInit(): void {
    this.proplayerAllData();
  }

  proplayerAllData() {
    this.isLoading = true;
    this.playerData
      .playerRecordData(
        this.proplayerData.value,
        this.pageNumber,
        this.SortDate,
        this.playerSide
      )
      .subscribe({
        next: (res) => {
          const decrypt=  this.decryptionApi.decrypt(res.payload);
          const jsondecrpt=JSON.parse(decrypt);
          this.playerdetails = jsondecrpt;
          this.isLoading = !this.playerdetails;

          this.playersRecord.push(...this.playerdetails);
        },
        error: (error) => {},
      });
  }

  formatDate(dateString: string) {
    if (dateString.match(/^\d{4}\.\d{2}\.\d{2}$/)) {
      const convertedDateString = dateString.replace(/\./g, '-');
      return this.datePipe.transform(convertedDateString, 'dd.MM.yyyy') || '';
    } else if (dateString.match(/^\d{4}\.\?\?.\?\?$/)) {
      const year = dateString.split('.')[0];
      return '--.--.' + year;
    } else {
      return 'Invalid Date Format';
    }
  }

  formatYear(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    value = value.replace(/\D/g, '');

    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    input.value = value;
    this.proplayerData.get('date')?.setValue(value);
  }

  filterData(data: any) {
    this.playerSide = data.side;
    this.filterForm = {
      date: data.date,
      name: data.name,
      opponent: data.opponent,
      results: data.results,
    };

    this.playersRecord = [];
    this.pageNumber = 1;
    this.playerData
      .playerRecordData(
        this.filterForm,
        this.pageNumber,
        this.SortDate,
        this.playerSide
      )
      .subscribe({
        next: (res) => {
          const decrypt=  this.decryptionApi.decrypt(res.payload);
          const jsondecrpt=JSON.parse(decrypt);
          this.playerdetails = jsondecrpt;
          this.isLoading = !this.playerdetails;
          this.playersRecord.push(...this.playerdetails);
        },
        error: (error) => {},
      });
  }

  onScroll(event: any) {
    const element = event.target as HTMLElement;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const totalHeight = element.scrollHeight;
    if (this.playerdetails.length == 0 || this.playerdetails.length < 20) {
      return;
    }

    if (scrollPosition >= totalHeight - 1 && !this.isLoading) {
      this.isLoading = true;
      this.pageNumber++;
      this.proplayerAllData();
    }
  }

  descendingDate(data: string) {
    this.playersRecord = [];
    this.SortDate = data;
    this.pageNumber = 1;
    this.proplayerAllData();
  }

  ascendingDate(data: string) {
    this.playersRecord = [];
    this.SortDate = data;
    this.pageNumber = 1;
    this.proplayerAllData();
  }

  whiteSide(data: string) {
    this.playersRecord = [];
    this.playerSide = data;
    this.pageNumber = 1;
    this.proplayerAllData();
  }

  blackSide(data: string) {
    this.playersRecord = [];
    this.playerSide = data;
    this.pageNumber = 1;
    this.proplayerAllData();
  }

  formReset() {
    this.proplayerData = this.fb.group({
      name: [''],
      opponent: [''],
      results: [''],
      date: [''],
      side: [''],
    });
    this.playersRecord = [];
    this.playerSide = '';
    this.pageNumber = 1;
    this.proplayerAllData();
    this.suggestions = [];
  }

  recondIddata(id: number) {
    const UserId = localStorage.getItem('loggedInUser');
    this.modalDisplayStyle = UserId !== null ? false : true;
    if (UserId !== null) {
      this.router.navigate(['historyboard', id]);
    }
  }

  GetChildData(data: any) {
    this.modalDisplayStyle = data;
  }

  playerInputChanges(data: any) {
    if (this.playerSearch) {
      this.playerSearch.unsubscribe();
    }

    this.playerNames = data.target.value;

    this.playerSearch = timer(1000)
      .pipe(
        switchMap(() => this.playerData.playerSuggestionData(this.playerNames))
      )
      .subscribe({
        next: (res) => {
          const decrypt=  this.decryptionApi.decrypt(res.payload);
          const jsondecrpt=JSON.parse(decrypt);
          this.suggestions = jsondecrpt;
        },
        error: (err) => {},
      });
  }

  opponentInputChange(data: any) {
    if (this.opponentPlayerSearch) {
      this.opponentPlayerSearch.unsubscribe();
    }

    this.playerOpponent = data.target.value;
    this.opponentPlayerSearch = timer(1000)
      .pipe(
        switchMap(() =>
          this.playerData.playerSuggestionData(this.playerOpponent)
        )
      )
      .subscribe({
        next: (res) => {
          const decrypt=  this.decryptionApi.decrypt(res.payload);
          const jsondecrpt=JSON.parse(decrypt);
          this.opponentsuggestions = jsondecrpt;
        },
        error: (err) => {},
      });
  }

  suggestionValue(data: string) {
    this.playerNames = data;
    this.suggestions = [];
  }

  opponentsuggestionValue(data: string) {
    this.opponentsuggestions = [];
    this.playerOpponent = data;
  }
}
